import { render, staticRenderFns } from "./shopTxt1Dialog.vue?vue&type=template&id=abe32430&scoped=true"
import script from "./shopTxt1Dialog.vue?vue&type=script&lang=js"
export * from "./shopTxt1Dialog.vue?vue&type=script&lang=js"
import style0 from "./shopTxt1Dialog.vue?vue&type=style&index=0&id=abe32430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe32430",
  null
  
)

export default component.exports